import SecondaryHeading from '@/components/typography/SecondaryHeading';

type FormTitleProps = {
  title: string;
};

export default function FormTitle({ title }: FormTitleProps) {
  return (
    <SecondaryHeading className="mb-3 text-xl md:text-2xl">
      {title}
    </SecondaryHeading>
  );
}
